<template>
    <b-card no-body>
        <b-modal body-class="p-0" id="payments" :title="['Ödemeler',viewData.FullName].join(' - ')" hide-footer no-close-on-esc no-close-on-backdrop>
            <div class="table-responsive">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th>Ödeme</th>
                            <th>Müktar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d,i) in (viewData.Payments || [])">
                            <td>{{ d.Key }}</td>
                            <td>{{ d.Value }}</td>
                        </tr>
                        <tr v-if="(viewData.Payments || []).length == 0">
                            <td colspan="2" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="c_fields"
                    pagination="server"
                    v-on:fetch-result-raw="onFetch"
                    :settings="false"
                    :buttons="buttons">
                <template #additional-actions>
                    <div class="row">
                        <div class="col-md-1 mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="donem.month">
                                <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-1 mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="donem.year">
                                <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                            </select>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="branchType">
                                <!-- <option value="O">Org. Şube</option> -->
                                <option value="S">SGK Şube</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'O'">
                            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                        </div>
                        <!-- <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'S'">
                            <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                        </div> -->
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <input class="form-control" placeholder="Personel" v-model="search"/>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="payments" label="name" v-model="paymentCompleted" placeholder="Ödemeler Tamamlandı Mı?"></v-select-list>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                        </div>
                        <div class="col-auto" v-if="excelPath">
                            <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                        </div>
                    </div>
                </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import moment from 'moment'
import Additional from '@/utilities/additional.js'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default{
    components:{
        BCard
    },
    data(){
        return {
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            payments:[
                {name:'Evet',value:true},
                {name:'Hayır',value:false},
            ],
            paymentCompleted:null,
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'S',
            branch:null,
            sbranch:null,
            collarStatus:null,
            excelPath:null,
            search:'',
            viewData:{
                FullName:null,
                Payments:[]
            },
            buttons:[
                { text:"Ödemeler",key:"payments",icon:"CreditCardIcon",variant:"primary",action:this.show },
            ],
            gettedMonth:{
                c:null,
                p:null
            }
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
    },
    methods:{
        provider(data){
            if(this.donem.month){
                const c = this.donem.month
                const p = this.donem.month - 1
                this.gettedMonth.c = this.months.find(m => m.index == c).name
                this.gettedMonth.p = this.months.find(m => m.index == p).name
            }
            return EmployeeOperationsApi.MediationReport({
                PaginateRequest:{
                    ...data,
                    QueryParam:this.search
                },
                ...this.filter,
                PaymentsCompleted:this.paymentCompleted?.value == false ? false : this.paymentCompleted?.value == true ? true : null
            })
        },
        onFetch(e){
            // Servis hata durumunda gövdesi boş (null) dönebiliyor. Önceden bu sessizce
            // yutuluyordu: ekran boş kalıyor, Excel butonu kayboluyor, kullanıcı sebebini
            // anlamıyordu. Artık durum kullanıcıya bildiriliyor.
            const data = e?.data
            if(!data){
                this.excelPath = null
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Döküm getirilemedi',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        text: 'Arabuluculuk dökümü getirilemedi. Seçtiğiniz dönemi kontrol edip tekrar deneyin; sorun sürerse yazılım ekibine bildirin.'
                    }
                })
                return
            }
            this.excelPath = data.ExcelPath
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        },
        show(item){
            this.viewData.FullName = null
            this.viewData.Payments = []
            this.viewData.FullName = item.FullName
            this.viewData.Payments = item.Payments
            this.$showModal('payments')
        }
    },
    computed:{
        filter(){
            return {
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        },
        c_fields(){
            return [
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Personel',key:'IdentityNumber'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Personel',key:'FullName'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'SGK Şube',key:'SGKBranch'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Unvan',key:'Title'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Yaka',key:'CollarStatus'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Son Ödeme Tarihi',key:'LastPaymentDateStr'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Ödemeler Tamamlandı Mı?',key:'PaymentCompleted'},
                {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Onay Kimden Alındı',key:'Approver'},
                {
                    name:'Kıdem Tazminatı',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Toplam Kıdem',key:'Kidem.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'Kidem.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Şirkete Borç Kesintisi',key:'Kidem.BorcStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'Kidem.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'Kidem.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'Kidem.KalanStr'}
                    ]
                },
                {
                    name:'İhbar Tazminatı',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Toplam İhbar',key:'Ihbar.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'Ihbar.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'Ihbar.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'Ihbar.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'Ihbar.KalanStr'}
                    ]
                },
                {
                    name:`${this.gettedMonth.p} Maaş`,
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Maaş Toplam',key:'M1.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'M1.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Şirkete Borcu  Kesintisi',key:'M1.BorcStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'M1.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'M1.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Bes Kesintisi',key:'M1.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'M1.KalanStr'},
                    ]
                },
                {
                    name:`${this.gettedMonth.c} Maaş`,
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Maaş Toplam',key:'M2.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'M2.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Şirkete Borç Kesintisi',key:'M2.BorcStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'M2.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'M2.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'BES Kesintisi',key:'M2.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'M2.KalanStr'},
                    ]
                },
                {
                    name:'Yıllık İzin',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Yıllık İzin Toplam',key:'YillikIzin.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'YillikIzin.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Şirkete Borç Kesintisi',key:'YillikIzin.BorcStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'YillikIzin.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'YillikIzin.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'BES Kesintisi',key:'YillikIzin.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'YillikIzin.KalanStr'},
                    ]
                },
                {
                    name:'Fazla Mesai',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Fazla Mesai Toplam',key:'FazlaMesai.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'FazlaMesai.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'FazlaMesai.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'FazlaMesai.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'BES Kesintisi',key:'FazlaMesai.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'FazlaMesai.KalanStr'},
                    ]
                },
                {
                    name:'Tatil Mesai',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Tatil Mesai Toplam',key:'TatilMesai.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'TatilMesai.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'TatilMesai.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'TatilMesai.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'BES Kesintisi',key:'TatilMesai.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'TatilMesai.KalanStr'},
                    ]
                },
                {
                    name:'Genel Tatil Mesai',
                    tdClass:'text-nowrap',thClass:'text-nowrap',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Genel Tatil Mesai Toplam',key:'GenelTatilMesai.TotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Çek İle Ödenen Kesintisi',key:'GenelTatilMesai.CekStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Avans Kesintisi',key:'GenelTatilMesai.AvansStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'İcra Kesintisi',key:'GenelTatilMesai.IcraStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'BES Kesintisi',key:'GenelTatilMesai.BesStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap',name:'Kalan',key:'GenelTatilMesai.KalanStr'},
                    ]
                },
                {
                    name:'Bordro Kontrol',
                    tdClass:'text-nowrap',thClass:'text-nowrap bg-light-secondary',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-secondary',name:'Bordro Toplam',key:'BordroTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-secondary',name:'Luca Bordro - Net İstikak',key:'LucaBordroTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-secondary',name:'Fark',key:'BordroDiffStr'},
                    ]
                },
                {
                    name:'Dip Toplam',
                    tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',
                    children:[
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Anlaşma Toplamı',key:'AgreedAmountStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Şirkete Borcu',key:'SirketeBorcuTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Toplam Çek',key:'CekTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Toplam Avans',key:'AvansTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Toplam İcra',key:'IcraTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Toplam BES',key:'BesTotalStr'},
                        {tdClass:'text-nowrap',thClass:'text-nowrap bg-light-danger',name:'Arabuluculuk Toplam Ödenecek',key:'TotalOdenecekStr'},
                    ]
                },
                // Tutarların 0 göründüğü satırlarda SEBEBİ de görünsün: eksik kıdem/ihbar
                // bordrosu, onaysız Banka 1 maaşı gibi durumlarda kalemler hesaplanmıyor ve
                // satır 0 basılıyordu; kullanıcı bunu "gerçekten 0" ile ayırt edemiyordu.
                // Backend bu sebepleri zaten Errors/ErrorsCommaSeperated olarak dönüyordu,
                // ekranda hiçbir sütun göstermiyordu ('unknown' anahtarı boş kalıyordu).
                {name:'Açıklama',key:'ErrorsCommaSeperated',tdClass:'text-danger',thClass:'text-nowrap'}
            ]
        }
    }
}
</script>